import React from 'react';
import { Phone, CalendarCheck, Shield } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
export function ResultsSection() {
  const outcomes = [{
    icon: <Phone className="w-8 h-8 text-[#c9a84c]" data-id="element-443" />,
    title: 'More Calls',
    desc: 'A website that makes your phone ring'
  }, {
    icon: <CalendarCheck className="w-8 h-8 text-[#c9a84c]" data-id="element-444" />,
    title: 'More Bookings',
    desc: 'Turn visitors into paying customers'
  }, {
    icon: <Shield className="w-8 h-8 text-[#c9a84c]" data-id="element-445" />,
    title: 'More Trust',
    desc: 'Look established and professional online'
  }];
  return <section id="results" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-446">
      <div className="max-w-6xl mx-auto" data-id="element-447">
        <div className="text-center mb-16 reveal" data-id="element-448">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-449">
            Real Results for{' '}
            <span className="gold-gradient-text" data-id="element-450">Real Businesses</span>
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto" data-id="element-451">
            Built to convert visitors into messages and calls.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-452">
          {outcomes.map((item, idx) => <div key={idx} className="premium-card p-8 rounded-xl text-center space-y-4 reveal" style={{
          transitionDelay: `${idx * 100}ms`
        }} data-id="element-453">
              <div className="bg-[#c9a84c]/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-454">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-white" data-id="element-455">{item.title}</h3>
              <p className="text-white/70" data-id="element-456">{item.desc}</p>
            </div>)}
        </div>
      </div>
      <SectionDivider data-id="element-457" />
    </section>;
}